import React from 'react'
import { Carousel } from 'react-bootstrap'
import { Link, useStaticQuery, graphql } from 'gatsby'

import 'bootstrap/dist/css/bootstrap.min.css'
import carouselStyles from './carousel.module.css'

const Carousels = () => {
    const { gcms } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                    }
                }
                gcms {
                    posts(orderBy: publishedAt_DESC) {
                        id
                        createdAt
                        title
                        category
                        image {
                            url
                        }
                        slug
                        body {
                            html
                        }
                    }
                }
            }
        `
    )

    const posts = gcms.posts

    function addDefaultSrc(ev) {
        ev.target.src =
            'https://www.pexels.com/photo/abandoned-black-and-white-abandoned-building-abandoned-hospital-5123471/'
    }

    return (
        <Carousel
            controls={true}
            indicators={false}
            className={carouselStyles.carousel}
        >
            {posts.map(post => {
                return (
                    <Carousel.Item className={carouselStyles.carouselItem}>
                        <Link to={post.slug}>
                            <img
                                className={`d-block w-100 ${carouselStyles.image}`}
                                onError={addDefaultSrc}
                                src={
                                    'https://images.pexels.com/photos/5123471/pexels-photo-5123471.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
                                }
                                alt="First slide"
                            />
                            <Carousel.Caption
                                className={carouselStyles.caption}
                            >
                                <h5>{post.title.length <= 45 ? post.title : `${post.title.substring(0, 50)}...`}</h5>
                            </Carousel.Caption>
                        </Link>
                    </Carousel.Item>
                )
            })}
        </Carousel>
    )
}

export default Carousels
